// extracted by extract-css-chunks-webpack-plugin
module.exports = {"explosion":"css-3p5hhLH6so","explosion_inner":"css-1VqzP9LdF8","explosion_inner_title":"css-jLxpRPKERe"};